import React, {useEffect, useRef, useState} from 'react';
import {connect} from 'react-redux';

import {
    updateChatFilters,
} from "../actions/Chats";
import {
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
    IonIcon,
    IonInput,
    IonMenuButton,
    IonImg, IonTitle,
} from '@ionic/react';
import {menuOutline, searchOutline, closeOutline} from 'ionicons/icons';


const Header = (
    {
        title,
        chatFilters,
        chatsRequestSending,
        updateChatFilters
    }
) => {


    const [searchToggle, setSearchToggle] = useState(false);
    const [searchInputValue, setSearchInputValue] = useState('');

    useEffect(() => {
        if (chatFilters?.search !== searchInputValue) {
            setSearchInputValue(chatFilters.search)
            if (chatFilters.search) {
                setSearchToggle(true)
            }
        }
    }, [chatFilters])

    const onSearchSubmit = (event, value = null) => {
        event.preventDefault();

        if (value === chatFilters.search) {
            // Уже сделали поиск по этому запросу
            return;
        }
        if (chatsRequestSending) {
            // Уже отослали запрос
            return;
        }
        updateChatFilters({
            search: value,
        });
    };

    const refIonInputSearch = useRef(null);

    return <>
        {searchToggle
            ? <>
                <IonInput
                    ref={refIonInputSearch}
                    placeholder="Search"
                    inputmode='search'
                    value={searchInputValue}
                    onIonChange={e => {
                        setSearchInputValue(e.detail.value);
                        onSearchSubmit(e, e.detail.value)
                    }}
                />
                <IonButtons slot="end">
                    <IonButton onClick={(e) => {
                        setSearchToggle(false);
                        setSearchInputValue('');
                        onSearchSubmit(e, '');
                    }}>
                        <IonIcon slot="icon-only" icon={closeOutline}/>
                    </IonButton>
                </IonButtons>
            </>
            : <>
                <IonTitle>{title}</IonTitle>
                <IonButtons slot="end">
                    <IonButton onClick={() => {
                        setSearchToggle(true);
                        setTimeout(() => refIonInputSearch.current.setFocus(), 10);
                    }}>
                        <IonIcon slot="icon-only" icon={searchOutline}/>
                    </IonButton>
                </IonButtons>
            </>
        }
    </>


}

const mapStateToProps = state => ({
    user: state.Auth.user,
    activeShop: state.Shops.activeShop,
    enableHeaderShadow: state.ThemeOptions.enableHeaderShadow,
    headerBackgroundColor: state.ThemeOptions.headerBackgroundColor,
    enableMobileMenuSmall: state.ThemeOptions.enableMobileMenuSmall,
    chatsRequestSending: state.Chats.chatsRequestSending,
    chatFilters: state.Chats.chatFilters,
});

const mapDispatchToProps = dispatch => ({
    updateChatFilters: (filtersToUpdate) => dispatch(updateChatFilters(filtersToUpdate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
